module.exports = __webpack_public_path__ + "static/media/pokeball.a97dda8c.svg";